<template>
  <section class="cuadro-ingreso">
    <form class="cuadro-ingreso__body" novalidate @submit.stop.prevent="login()">
      <div class="text--center">
        <img src="/static/controles_contra.png" class="logo-login img--center" alt="Trakapp Logo">
      </div>
      <form-group :error="errors.has(ids.correo) && submitted">
        <input type="text"
               autofocus
               :id="ids.correo"
               :name="ids.correo"
               class="form__input form__input--blanco"
               v-model="usuario"
               v-validate="'required'"
               @input="usuario = usuario.toLowerCase()">
        <label :for="ids.correo" class="form__label form__input--blanco">Correo electrónico</label>
      </form-group>
      <form-group :error="errors.has(ids.password) && submitted">
        <input type="password"
               :id="ids.password"
               :name="ids.password"
               class="form__input form__input--blanco"
               v-model="password"
               v-validate="'required'">
        <label :for="ids.password" class="form__label form__input--blanco">Contraseña</label>
      </form-group>
      <div class="text--center">
        <button class="boton boton--celeste-tema boton--l" type="submit">
          <i class="fa fa-fw fa-sign-in"/>
          Iniciar sesión
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import D from "debug";
import noop from "lodash/noop";
import id from "./ids.js";

const debug = D("ciris:Login.vue");
export default {
  data,
  created,
  methods: {
    login,
  },
};

function data() {
  return {
    ids: {},
    usuario: "",
    password: "",
    recordar: true,
    submitted: false,
  };
}

function created() {
  this.ids = {
    correo: `correo-${id()}`,
    password: `password-${id()}`,
  };
}

function login() {
  this.submitted = true;
  return this.$validator.validateAll().then((valido) => {
    if (valido) {
      return this.$auth.login(this.usuario, this.password, this.recordar)
        .then((resp) => {
          debug(resp);
          this.$router.push({ name: "grafos" });
          this.$toastr("success", "Sesión inicada con éxito", `${resp.usuario}`);
          return resp;
        })
        .catch((err) => {
          debug(err);
          if (err.response.status < 500) {
            this.$toastr("info", "Credenciales inválidos", "Usuario inválido");
          } else {
            this.$toastr("error", "Hubo un error al iniciar sesión", "Error");
          }
        });
    }
    return noop;
  });
}
</script>

<style lang="scss">
@import "../sass/base/colores";
@import "../sass/base/helpers";

.cuadro-ingreso {
  align-items: center;
  flex-direction: column;
  background: transparentize($grisa, .6);
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
}

.cuadro-ingreso__body {
  @extend .sombra;
  background: transparentize($negro2, .1);
  border-radius: 4px;
  padding: 15px 0;
  width: 90%;

  @media (min-width: 992px) {
    padding: 1em;
    width: 700px;
  }
}

.cuadro-ingreso__body--l{
  @media (min-width: 992px) {
    padding: 1em;
    width: 700px;
  }
}

.login__label {
  font-size: 90%;
  font-weight: bolder;
}

.login__boton {
  margin-top: 15px;
  width: 96%;
}

.form__input--blanco {
  color: $blanco;
}

.logo-login{
  max-width: 100%;
  height: 170px;
}

.text--registro{
  padding-top: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue